import React from "react";

import { BulkEditActivity } from "app/userManagement/modules/generic";

const OperatorBulkEditActivity = () => {
  return <BulkEditActivity />;
};

export default OperatorBulkEditActivity;
